import { render, staticRenderFns } from "./CodeEditors.vue?vue&type=template&id=01894058"
import script from "./CodeEditors.vue?vue&type=script&lang=js"
export * from "./CodeEditors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports